// src/pages/AboutPage.jsx
import FAQ from '../components/Faq'
import FounderSection from '../components/Founder'
import HaronicsProfile from '../components/HaronicsProfile'
import Process from '../components/Process'
import TrustedBrands from '../components/Trade'
import VideoGrid from '../components/Video-grid'
import { Helmet } from "react-helmet";

export default function AboutPage() {
  return (
    <>
      <Helmet>
        <title>Haronics - Cold Pressed Oils</title>
        <meta name="description"
          content="Buy premium quality cold pressed oils from Haronics. 100% pure, traditional wooden ghani oils." />
        <meta
          name="keywords"
          content="Haronics cold pressed oils, Haronics wooden ghani oils, Haronics chemical-free cooking oil, Haronics coconut oil, Haronics edible oils India"
        />
      </Helmet>
      <FounderSection />
      <HaronicsProfile />
      <Process />
      <TrustedBrands />
      <VideoGrid />
      <FAQ />
    </>
  )
}
